const {h, render, Component} = require('preact');
const FinePrint = require('../fine_print')
const UsageInstructionsView = require('../../self_service_actions/gplus/usage_instructions')

class SSALinks extends Component {
  constructor(props) {
    super(props);
    this.getFinePrintInformation = this.getFinePrintInformation.bind(this)
  }

  showFinePrint() {
    if (lodash.has(this.props.claimDetails, 'finePrint')) {
      return (this.props.claimDetails.finePrint.length > 0);
    }
    return false;
  }

  showUsageInstructions() {
    if (lodash.has(this.props.claimDetails, 'pitchHtml')) {
      return (this.props.claimDetails.pitchHtml.length > 0);
    }
    return false;
  }

  getFinePrintInformation() {
    if (this.props.claimDetails.finePrint) {
      if (/<[a-z][\s\S]*>/i.test(this.props.claimDetails.finePrint)) { // Checks if any HTML elements are present
        return <div
          class="ssa-information"
          dangerouslySetInnerHTML={{__html: this.props.claimDetails.finePrint}}
        />
      }
      else {
        return (
          <div class="ssa-information">
            {this.props.claimDetails.finePrint}
          </div>
        );
      }
    }
    return null;
  }

  render() {
    return (
      <div>
        {this.showFinePrint() &&
        <FinePrint
          getFinePrintInformation={this.getFinePrintInformation()}
        />
        }
        {this.showUsageInstructions() &&
        <UsageInstructionsView claimDetails={this.props.claimDetails}/>
        }
      </div>
    );
  }
}

module.exports = SSALinks
